import { ILeadInput } from '@user/store/lead'
import { addLeadFieldsToCheckNonRequiredErrors } from '@user/components/Settings/EntityFormSettings'
import type {
  FieldSettingsMap,
  ICustomFieldFormSetting,
} from '@user/store/entityFormSettings'

export const useRemoveHiddenFieldsFromAPI = (
  entitySettingsMap: FieldSettingsMap,
  customFieldSettings: ICustomFieldFormSetting[],
) => {
  const removeHiddenFieldsFromAPI = (leadData: ILeadInput) => {
    const cleanedLeadData = { ...leadData }

    addLeadFieldsToCheckNonRequiredErrors.forEach((field) => {
      const [isRequired, hasEnabled] = entitySettingsMap.get(field.name) ?? [
        false,
        false,
      ]
      if (!isRequired && !hasEnabled) {
        field.errorFields.filter((errorField) => {
          delete cleanedLeadData[errorField]
        })
      }
    })

    customFieldSettings.map((cs) => {
      if (!cs.required && !cs.enabled) {
        cleanedLeadData.customFieldValues.map((customField) => {
          if (customField.customFieldId !== cs.customFieldId) return customField
        })
      }
    })

    return cleanedLeadData
  }

  return { removeHiddenFieldsFromAPI }
}
